import {observer} from "mobx-react-lite";
import {useServices} from "../../../../react-hooks/use-services.hook";
import {VideoSlidesArenaContentBox} from "./boxes/video-slides-arena-content.box";
import {Navigation, Virtual} from 'swiper/modules';
import {SwiperSlide} from "swiper/react";
import {VideoSlidesArenaSwiperComponentBox} from "./boxes/video-slides-arena-swiper-component/video-slides-arena-swiper-component.box";

export const VideoSlidesContentArena: React.FC = observer(() => {
    const services = useServices();
    const currentLoadedShorts = services.videoSlides.slideList;
    const slideIndex = services.videoSlides.slideIndex;

    return (
        currentLoadedShorts.length && <VideoSlidesArenaContentBox>
            <VideoSlidesArenaSwiperComponentBox modules={[Navigation, Virtual]}
                slidesPerView={1}
                initialSlide={slideIndex}
                direction={"vertical"}
                virtual={{
                    enabled: true,
                    addSlidesAfter: 3,
                }}
                onActiveIndexChange={(swiper) => services.videoSlides.slideIndex = swiper.activeIndex}>
                {
                    currentLoadedShorts.map((renderer, index) => {
                        return (
                            <SwiperSlide key={renderer.uniqueKey} virtualIndex={index}>
                                {renderer.render()}
                            </SwiperSlide>
                        )
                    })
                }
            </VideoSlidesArenaSwiperComponentBox>
        </VideoSlidesArenaContentBox>
    );
})